import { ToggleButton as MuiToggleButton, styled } from "@mui/material";
import { BUTTON_COLORS } from "../../constants";

export const ToggleButton = styled(MuiToggleButton)(({ size }) => ({
  borderRadius: "4px",
  textTransform: "initial",
  background: "rgba(0,0,0,0)",
  color: BUTTON_COLORS.primary,
  boxShadow: "none",
  border: `1px solid #181D1F26`,
  fontSize: "12px",
  fontWeight: 500,
  letterSpacing: 0,
  // minWidth: "60px",
  padding: "2px 8px",
  transition: "all 0.2s linear",
  height: size === "large" ? "38px" : size === "medium" ? "28px" : "22px",

  "&:hover": {
    background: `${BUTTON_COLORS.primaryHover}`,
    border: `1px solid ${BUTTON_COLORS.primaryHover}`,
    color: "#FFFFFF",
  },

  "&.Mui-selected": {
    background: BUTTON_COLORS.primary,
    color: "#FFFFFF",

    "&:hover": {
      background: `${BUTTON_COLORS.primaryHover}`,
      color: "#FFFFFF",
    },
  },

  "@media(hover:none)": {
    "&:hover": {
      background: "rgba(0,0,0,0)",
      border: `1px solid ${BUTTON_COLORS.primary}`,
      color: BUTTON_COLORS.primary,
    },
  },
}));

export default ToggleButton;
